import { render, staticRenderFns } from "./CollectionsLineItemsModal.vue?vue&type=template&id=6f42c5fa&scoped=true&"
import script from "./CollectionsLineItemsModal.vue?vue&type=script&lang=ts&"
export * from "./CollectionsLineItemsModal.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionsLineItemsModal.vue?vue&type=style&index=0&id=6f42c5fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f42c5fa",
  null
  
)

export default component.exports